import {
  getStaffMemberSettings as publicGetStaffMemberSettings,
  updateStaffMemberSettings as publicUpdateStaffMemberSettings,
} from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onStaffMemberSettingsUpdated as publicOnStaffMemberSettingsUpdated } from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.public.js';

export const getStaffMemberSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetStaffMemberSettings> &
    typeof publicGetStaffMemberSettings
> = /*#__PURE__*/ createRESTModule(publicGetStaffMemberSettings);
export const updateStaffMemberSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateStaffMemberSettings> &
    typeof publicUpdateStaffMemberSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateStaffMemberSettings);
/**
 * Triggered when a `staffMemberSettings` object is updated.
 */
export const onStaffMemberSettingsUpdated: BuildEventDefinition<
  typeof publicOnStaffMemberSettingsUpdated
> &
  typeof publicOnStaffMemberSettingsUpdated = /*#__PURE__*/ createEventModule(
  publicOnStaffMemberSettingsUpdated
);

export { WebhookIdentityType } from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.universal.js';
export {
  StaffMemberSettings,
  ContactInformation,
  StaffProperties,
  ExtendedFields,
  GetStaffMemberSettingsRequest,
  GetStaffMemberSettingsResponse,
  UpdateStaffMemberSettingsRequest,
  UpdateStaffMemberSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  StaffMemberSettingsUpdatedEnvelope,
} from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.universal.js';
export { WebhookIdentityTypeWithLiterals } from './bookings-staff-settings-v1-staff-member-settings-staff-member-settings.universal.js';
